export const environment = {
  env: "develop",
  production: true,
};
